module.exports = __webpack_public_path__ + "img/ribbon.7705bda4.svg";